const updates = [
  { title: '鬼灭之刃', chapter: '第206话', desc: '最终决战！炭治郎与无惨的宿命对决', time: '2小时前', hot: true },
  { title: '咒术回战', chapter: '第263话', desc: '五条悟复活？宿傩的最终形态揭晓', time: '3小时前', hot: true },
  { title: '海贼王', chapter: '第1125话', desc: '路飞觉醒！尼卡形态的终极力量', time: '5小时前', hot: true },
  { title: '间谍过家家', chapter: '第98话', desc: '阿尼亚的校园祭大作战', time: '6小时前', hot: false },
  { title: '怪兽8号', chapter: '第115话', desc: '日比野卡夫卡的真正身份曝光', time: '8小时前', hot: false },
  { title: '电锯人', chapter: '第178话', desc: '战争恶魔的真实目的浮出水面', time: '10小时前', hot: false },
  { title: '坂本days', chapter: '第137话', desc: '昔日最强杀手今日便利店店员', time: '12小时前', hot: false },
  { title: '蓝色监狱', chapter: '第242话', desc: 'U-20世界杯半决赛开战', time: '14小时前', hot: false },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-18 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center">
            更新动态
          </h2>
          <p className="mt-2 text-sm text-foreground-500 text-center">
            最新漫画章节更新，第一时间追踪热门作品
          </p>
          <div className="mt-8 relative">
            <div className="absolute left-4 top-0 bottom-0 w-px bg-background-200"></div>
            <div className="space-y-1">
              {updates.map((item, idx) => (
                <div key={idx} className="relative flex items-start gap-5 pl-10 py-3 group cursor-pointer">
                  <div className={`absolute left-2.5 top-4 w-3 h-3 rounded-full border-2 border-background-50 ${
                    item.hot ? 'bg-primary-500' : 'bg-background-300'
                  }`}></div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors">
                        {item.title}
                      </span>
                      <span className="text-xs text-primary-600 font-medium whitespace-nowrap">
                        {item.chapter}
                      </span>
                      {item.hot && (
                        <span className="text-xs px-1.5 py-0.5 rounded bg-primary-100 text-primary-700 whitespace-nowrap">
                          HOT
                        </span>
                      )}
                    </div>
                    <p className="mt-0.5 text-xs text-foreground-500">{item.desc}</p>
                  </div>
                  <span className="text-xs text-foreground-400 shrink-0 mt-1 whitespace-nowrap">
                    {item.time}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}